import { uniqueId } from 'lodash'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { RootState } from '../../../../../states/containers/store'
import { setPath, setUrlParam } from '../../../../../utils/url'
import { URL } from '../../../../constants/url'
import Loading from '../../../common/Loading'

type LangValue = 'ja' | 'en'

interface Score {
  efficiency_score: number
  focus_score: number
  stress_score: number
}

const WeeklyMember: FC = () => {
  const { language } = useParams<{ language: LangValue }>()
  const history = useHistory()
  const location = useLocation()

  const {
    report,
  } = useSelector((state: RootState) => (state))

  const clickMemberLink = (id: number) => {
    history.push(`${setPath(setUrlParam(
      URL.REPORT_DETAIL_WEEKLY.path,
      [
        { key: 'target', value: "member" },
        { key: 'id', value: id.toString() },
      ],
    ), language)}?date=${report.weeklyTeamReport?.date?.from}`, { referrer: `${location.pathname}${location.search}` })
  }

  const bg_color = (totalEvaluation: string) => {
    if (!totalEvaluation) return "#FFF"
    if (totalEvaluation === 'Excellent') return "#446BF4"
    if (totalEvaluation === 'Great') return "#44B5F4"
    if (totalEvaluation === 'Good') return "#4C5B7B"
    if (totalEvaluation === 'Fair') return "#446BF4"
    return "#FFF"
  }

  const memberBlock = (
    job: string, name: string, id: number, icon: string | null, controlled: boolean, is_member = false, score?: Score, total_evaluation?: string,
  ) => (
    <div className={`member_block ${is_member ? "member" : "manager"}`}>
      <div className="flex">
        <div className="user_icon">
          {
            icon ? (
              <img alt="" src={icon} style={{ width: "100%", borderRadius: "50%" }} />
            ) : (
              <img alt="" src={`/static/images/profile/${(id || 0) % 12}.jpeg`} style={{ width: "100%", borderRadius: "50%" }} />
            )
          }
        </div>
        <div>
          <div className="role">
            {job}
          </div>
          <div className="name no_trans">
            {name}
          </div>
        </div>
      </div>
      {
        !!total_evaluation && (
          <div
            className="total_evaluation"
            style={{
              backgroundColor: bg_color(total_evaluation),
            }}
          >
            {total_evaluation}
          </div>
        )
      }
      {
        score && (
          <>
            <div className="score_area">
              <div className="item">
                <div className="text">
                  業務効率適正度
                </div>
                <div className="point">
                  {score.efficiency_score || "-"}
                </div>
              </div>
              <div className="item">
                <div className="text">
                  業務負荷適正度
                </div>
                <div className="point">
                  {score.stress_score || "-"}
                </div>
              </div>
              <div className="item">
                <div className="text">
                  業務集中適正度
                </div>
                <div className="point">
                  {score.focus_score || "-"}
                </div>
              </div>
            </div>
            {
              controlled && (
                <div className="button_area">
                  <button
                    data-gtm-click="個人レポートを見る - button"
                    type="button"
                    onClick={() => clickMemberLink(id)}
                  >
                    週間個人レポートを見る
                  </button>
                </div>
              )
            }
          </>
        )
      }
    </div>
  )

  return (
    <>
      {
        report.isLoading ? (
          <>
            <Loading />
          </>
        ) : (
          <section id="weekly_member" className="page_contents">
            <div className="content-block weekly">
              <div className="block-header">
                <div className="title">
                  メンバー
                </div>
              </div>
              <div className="block-detail">
                <div className="member_area">
                  <div className="title">
                    マネージャー
                  </div>
                  <div className="manager_card_area">
                    {
                      report.weeklyTeamReport?.team?.managers.map((manager) => (
                        <React.Fragment key={uniqueId()}>
                          {memberBlock("マネージャー", manager.name, manager.id, manager.image_url, true)}
                        </React.Fragment>
                      ))
                    }
                  </div>
                  <div className="title">
                    メンバー
                  </div>
                  <div className="member_card_area">
                    {
                      report.weeklyTeamReport?.team?.members.map((member) => (
                        <React.Fragment key={uniqueId()}>
                          {memberBlock("メンバー", member.name, member.id, member.image_url, member.controlled, true,
                            {
                              efficiency_score: member.efficiency_score,
                              focus_score: member.focus_score,
                              stress_score: member.stress_score,
                            },
                            member.total_evaluation)}
                        </React.Fragment>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div>
          </section>
        )
      }
    </>
  )
}

export default WeeklyMember
